import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/me')
      .then(r => r.ok ? r.json() : null)
      .then(data => { setUser(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const logout = () => {
    fetch('/auth/logout', { method: 'POST' }).then(() => {
      setUser(null);
      window.location.href = '/login';
    });
  };

  const canSync = () => ['admin','accountant'].includes(user?.role);
  const canEdit = () => user?.role === 'admin';

  return (
    <AuthContext.Provider value={{ user, loading, logout, canSync, canEdit }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const isAdmin      = (u) => u?.role === 'admin';
export const isAccountant = (u) => u?.role === 'accountant' || isAdmin(u);
export const isBDM        = (u) => u?.role === 'bdm' || isAccountant(u);
export const canSeeCost       = (u) => isAccountant(u);
export const canSeeMargin     = (u) => isAccountant(u);
export const canSeeSellPrice  = (u) => isBDM(u);
export const canSeeInvoiceAmt = (u) => isBDM(u);
export const canRunSync       = (u) => isAccountant(u);
export const canEditPricing   = (u) => isAdmin(u);
export const canEditMappings  = (u) => isAdmin(u);
export const canManageUsers   = (u) => isAdmin(u);
export const canExport        = (u) => isAccountant(u);
export const canSeeAuditLog   = (u) => isAccountant(u);
export const canSeePortalSettings = (u) => isAdmin(u);
